import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import * as ActionsDialog from 'app/store/actions';

import { API_BASE_URL } from '@config';
import { saveAs } from 'file-saver';

export const SET_SELECTED = 'SET SELECTED';
export const setSelected = file => ({
	type: SET_SELECTED,
	payload: file
});

export const DOWNLOAD_FILE_REQUEST = 'DOWNLOAD_FILE_REQUEST';
export const downloadFileRequest = () => ({
	type: DOWNLOAD_FILE_REQUEST
});

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const clearError = () => ({
	type: CLEAR_ERROR
});

export const SET_FILES = 'SET_FILES';
export const setFiles = files => ({
	type: SET_FILES,
	payload: files
});

export const SET_FILE = 'SET_FILE';
export const setFile = file => ({
	type: SET_FILE,
	payload: file
});

export const SET_FILE_ACTION_ERROR = 'SET_FILE_ACTION_ERROR';
export const setFileActionError = err => ({
	type: SET_FILE_ACTION_ERROR,
	payload: err
});

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const setSearchText = event => ({
	type: SET_SEARCH_TEXT,
	searchText: event.target.value
});

export const CLEAR_FILES_REDUCER = 'CLEAR_FILES_REDUCER';
export const clearFilesReducer = () => ({
	type: CLEAR_FILES_REDUCER
});

export const getFiles = cluster => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/jobs/outputs/${cluster}`);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			if (response.data.length === 0) {
				dispatch(setFiles(null));
			} else dispatch(setFiles(response.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setFileActionError({ ...err.data, type: 'modal' }));
		});
};

export const getFilesNoLoading = cluster => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/jobs/outputs/${cluster}`);
	return request
		.then(response => dispatch(setFiles(response.data)))
		.catch(err => dispatch(setFileActionError({ ...err.data, type: 'modal' })));
};

export const getFile = (cluster, job, type) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/jobs/output/${cluster}/${job}/${type}`);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setFile(response.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setFileActionError({ ...err.data, type: 'modal' }));
		});
};

export const downloadFile = (cluster, job, type, name) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	dispatch(downloadFileRequest());
	const request = axios.get(`${API_BASE_URL}/api/jobs/downloadOutput/${cluster}/${job}/${type}`, {
		responseType: 'blob'
	});
	return request
		.then(response => {
			saveAs(response.data, `${job}-${name}-${type}.txt`);
			dispatch(ActionsDialog.toggleLoading());
		})
		.catch(err => dispatch(setFileActionError({ ...err.data, type: 'modal' })));
};

export const deleteFile = (cluster, jobs) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	dispatch(showMessage({ message: 'Deleting File' }));
	const request = axios.delete(`${API_BASE_URL}/api/jobs/deleteOutput/${cluster}`, { data: { jobs: [...jobs] } });
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(showMessage({ message: 'File Deleted' }));
			dispatch(getFilesNoLoading(cluster));
		})
		.catch(err => dispatch(setFileActionError({ ...err.data, type: 'modal' })));
};
